import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const updateBaseInformationSchema = (displayDisciplineField = false) =>
  yup.object().shape({
    status: yup
      .object()
      .label(t('labelStatus'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelStatus'))),
    externalLocationRegion: yup.string().label(t('labelTheatre')).nullable(),
    externalLocationCountry: yup.object().label(t('labelExternalLocationCountry')).nullable(),
    customerCompanyName: yup.string().label(t('labelCustomerCompanyName')).nullable(),
    customerNumber: yup.string().label(t('labelCustomerNumber')).nullable(),
    requestedByUser: yup.object().label(t('labelRequestedBy')).nullable(),
    requestedByUserEmployeeId: yup.string().label(t('labelRequestedByUserEmployeeId')).nullable(),
    supportUser: yup.object().label(t('labelSupportUser')).nullable(),
    dueDate: yup.string().label(t('labelDueDate')).nullable(),
    supportCompletedDate: yup.string().label(t('labelSupportCompletedDate')).nullable(),
    ...(displayDisciplineField && {
      discipline: yup.object().label(t('labelDiscipline')).nullable(),
    }),
    ...(!displayDisciplineField && {
      discipline: yup.object().label(t('labelDiscipline')).nullable(),
    }),
  });
